<template>
  <div class="sidebar-logo-container">
    <router-link class="sidebar-logo-link" to="/">
      <img :src="smallLogo" class="sidebar-logo" />
    </router-link>
  </div>
</template>

<script>
import flavours from "@/mixins/flavours";

export default {
  name: "SidebarLogo",
  mixins: [flavours],
  data() {
    return {
      title: "Operadora",
    };
  },
};
</script>

<style lang="scss" scoped>
.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  background: #2b2f3a;
  text-align: center;
  overflow: hidden;
  width: 54px;

  .sidebar-logo-link {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .sidebar-logo {
      width: 42px;
      padding: 5px 0 4px;
      vertical-align: middle;
    }

    .sidebar-title {
      padding-top: 4px;
      color: white;
      font-size: 10px;
    }
  }
}
.neositek {
  .sidebar-logo {
    width: 34px !important;
  }
}
</style>
